export default function TS_Casting() {
  return (
    <div>
      <h1>TS Casting</h1>
      <p>This is the TS Casting page.</p>
    </div>
  );
}